import { createReducer, on } from "@ngrx/store";
import { User } from "../../../models/user.model";
import { userActions } from "../user.actions";

export interface UserInfoState {
    user: User|null,
    state: 'pending'|'loading'|'loaded'|'error'
}

export const initialState: UserInfoState = {
    user: null,
    state: 'pending'
}

export const userInfoReducer = createReducer(
    initialState,
    on(userActions.getUserInfo, (state) => ({
        ...state,
        user: null,
        state: 'loading' as const
    })),
    on(userActions.getUserInfoSuccess, (state, {payload}) => ({
        ...state,
        user: payload,
        state: 'loaded' as const
    })),
    on(userActions.getUserInfoFail, (state) => ({
        ...state,
        user: null,
        state: 'error' as const
    }))
)